import React, { useCallback, useEffect } from 'react';
import { Fade } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import SearchIconDetails from 'assets/svg/searchIconDetails.svg';
import { InventoryData } from 'utils/interfaces/Log';
import { Table } from 'components/Tools/Table';
import { TableContainer } from 'app/WMS/styles/styles';
import { IReportsBatchTableProps } from '../../types';

const BatchTable: React.FC<IReportsBatchTableProps> = ({
  rows,
  setDetailsModal,
  setModalData,
}) => {
  const { t } = useTranslation();

  const handleActionClick = useCallback(
    (row: InventoryData) => {
      setModalData(row);
      setDetailsModal(true);
    },
    [setDetailsModal, setModalData]
  );

  useEffect(() => {
    setModalData({} as InventoryData);
  }, [setModalData]);

  return (
    <Fade in timeout={1000} unmountOnExit>
      <TableContainer>
        <Table<InventoryData>
          columns={[
            {
              title: String(t('screens.orderFollowUp.title')),
              type: 'string',
              props: ['pedido'],
              orderable: true,
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '12%',
              },
            },
            {
              title: String(t('screens.structureAdresses.type')),
              props: ['tipo'],
              type: 'stringCenter',
              orderable: true,
            },
            {
              title: String(t('screens.reportsStock.address')),
              orderable: true,
              type: 'string',
              props: ['endereco'],
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '12%',
              },
            },
            {
              title: String(t('screens.commom.product')),
              props: ['produto'],
              type: 'stringCenter',
              orderable: true,
            },
            {
              title: String(t('screens.reportsStock.descriptionProduct')),
              orderable: true,
              type: 'string',
              props: ['descricaoProduto'],
              cssTitle: {
                width: '1%',
              },
              cssProps: {
                width: '12%',
              },
            },
            {
              title: String(t('screens.commom.size')),
              orderable: true,
              type: 'string',
              props: ['tamanho'],
            },
            {
              title: String(t('screens.commom.color')),
              orderable: true,
              type: 'string',
              props: ['cor'],
            },
            {
              title: String(t('screens.commom.quantity')),
              props: ['quantidade'],
              type: 'stringCenter',
              orderable: true,
            },
            {
              title: String(t('screens.commom.user')),
              props: ['usuario'],
              type: 'stringCenter',
              orderable: true,
            },
            {
              title: String(t('screens.manualOrder.date')),
              props: ['data'],
              type: 'datetime',
              orderable: true,
              display: 'notEmpty',
            },
            {
              title: String(t('screens.pickingConference.bathModalTitle')),
              orderable: true,
              type: 'stringCenter',
              props: ['lote'],
            },
            {
              title: String(t('screens.pickingConference.validity')),
              type: 'stringCenter',
              orderable: true,
              props: ['validade'],
            },
            {
              title: String(t('screens.receivement.series')),
              orderable: true,
              type: 'stringCenter',
              props: ['serie'],
            },
            {
              title: String(t('screens.commom.actions')),
              type: undefined,
              props: [''],
              renderItem: row => (
                <div className="row-actions-button-detail">
                  <button
                    type="button"
                    className="action"
                    onClick={() => handleActionClick(row)}
                  >
                    <img
                      src={SearchIconDetails}
                      alt="Detalhes"
                      style={{ width: '30px' }}
                    />
                    <p className="hover-item">{t('screens.commom.details')}</p>
                  </button>
                </div>
              ),
            },
          ]}
          defaultNumberOfRows={10}
          rows={rows}
          exportList
        />
      </TableContainer>
    </Fade>
  );
};

export default BatchTable;
